import amapi from '@/api/amapi'

const initialState = () => ({
  domains_list: [],
  default_account: [],

  emails: {
    data: [],
    default_account_data: [],
    sharedbook_status: false,
    loading_status: false,
    default_account_loading_status: false
  },
  forwarders: {
    domain: '',
    forwarders: [],
    domain_forwarders: [],
    loading_status: false
  },
  responders: {
    domain: '',
    data: [],
    responder: {},
    loading_status: false
  },
  charsets: {
    data: [],
    loading_status: false
  },
  default_address: {
    domain: '',
    data: {},
    loading_status: false
  },
  mailing_list: {
    data: [],
    delegates: {
      delegates: [],
      emails: [],
      loading_status: false
    },
    loading_status: false
  },
  filters: {
    selected_account: '',
    list: [],
    single: {},
    filters_loading_status: false,
    filter_loading_status: false,
    filter_by_user_loading_status: false,
  },
  authentication: {
    dkim: {
      data: [],
      status: {},
      loading_status: false
    },
    spf: {
      data: [],
      status: false,
      loading_status: false
    }
  },
  spam_assasin: {
    settings: {},
    loading_status: false
  },
  // spam_filters: {
  //   spam_enabled: false,
  //   other: {}
  // }
})

const state = initialState

const getters = {
  domains_list: state => state.domains_list,
  default_account: state => state.default_account,
  emails: state => state.emails,
  forwarders: state => state.forwarders,
  responders: state => state.responders,
  charsets: state => state.charsets,
  default_address: state => state.default_address,
  mailing_list: state => state.mailing_list,
  filters: state => state.filters,
  authentication: state => state.authentication,
  // spam_assasin: state => state.spam_assasin,
  // spam_filters: state => state.spam_filters
}

const mutations = {
  SET_DOMAINS: (state, payload) => {
    state.domains_list = []

    let mainDomain = { main_domain: payload.main_domain }
    let subDomains = { sub_domains: payload.sub_domains }
    let addonDomains = { addon_domains: payload.addon_domains }
    let parkedDomains = { parked_domains: payload.parked_domains }

    state.domains_list = state.domains_list.concat(mainDomain, subDomains, addonDomains, parkedDomains)
  },
  // SET_DEFAULT_ACCOUNT: (state, payload) => {
  //   state.default_account = payload
  // },

  SET_EMAILS_DATA: (state, payload) => {
    state.emails.data = payload
  },
  SET_EMAILS_LOADING: (state, payload) => {
    state.emails.loading_status = payload
  },
  SET_SHARED_BOOK_STATUS: (state, payload) => {
    state.emails.sharedbook_status = !!+payload
  },
  SET_DEFAULT_ACCOUNT_DATA: (state, payload) => {
    state.emails.default_account_data = [payload]
  },
  SET_DEFAULT_ACCOUNT_LOADING: (state, payload) => {
    state.emails.default_account_loading_status = payload
  },

  SET_FORWARDER_DOMAIN: (state, payload) => {
    state.forwarders.domain = payload
  },
  SET_LIST_FORWARDERS: (state, payload) => {
    state.forwarders.forwarders = payload
  },
  SET_LIST_DOMAINS_FORWARDERS: (state, payload) => {
    state.forwarders.domain_forwarders = payload
  },
  SET_FORWARDER_LOADING: (state, payload) => {
    state.forwarders.loading_status = payload
  },

  SET_RESPONDERS_DOMAIN: (state, payload) => {
    state.responders.domain = payload
  },
  SET_RESPONDERS: (state, payload) => {
    state.responders.data = payload
  },
  SET_RESPONDER: (state, payload) => {
    state.responders.responder = payload
  },
  SET_RESPONDERS_LOADING: (state, payload) => {
    state.responders.loading_status = payload
  },
  SET_CHARSETS: (state, payload) => {
    state.charsets.data = payload
  },
  SET_CHARSET_STATUS: (state, payload) => {
    state.charsets.loading_status = payload
  },

  SET_ADDRESS_DOMAIN: (state, payload) => {
    state.default_address.domain = payload
  },
  SET_ADDRESS_DATA: (state, payload) => {
    state.default_address.data = {}
    state.default_address.data = payload
  },
  SET_ADDRESS_LOADING: (state, payload) => {
    state.default_address.loading_status = payload
  },

  SET_MAILING_LIST_DATA: (state, payload) => {
    state.mailing_list.data = payload
  },
  SET_MAILING_DELEGATES: (state, { admins, users }) => {
    state.mailing_list.delegates.delegates = admins
    state.mailing_list.delegates.emails = users
  },
  SET_MAILING_DELEGATES_LOADING: (state, payload) => {
    state.mailing_list.delegates.loading_status = payload
  },
  SET_MAILING_LIST_LOADING: (state, payload) => {
    state.mailing_list.status = payload
  },

  SET_FILTERS_DATA: (state, payload) => {
    state.filters.list = payload
  },
  SET_FILTER_DATA: (state, payload) => {
    state.filters.single = payload
  },
  SET_FILTERS_BY_USER: (state, payload) => {
    state.filters.list_by_user = payload
  },
  SET_FILTERS_BY_USER_LOADING: (state, payload) => {
    state.filters.filter_by_user_loading_status = payload
  },
  SET_FILTERS_LOADING: (state, payload) => {
    state.filters.filters_loading_status = payload
  },
  SET_FILTER_LOADING: (state, payload) => {
    state.filters.filter_loading_status = payload
  },

  SET_DKIM_STATUS: (state, payload) => {
    state.authentication.dkim.status = payload
  },
  SET_SPF_STATUS: (state, payload) => {
    state.authentication.spf.status = payload
  },
  SET_DKIM_DATA: (state, payload) => {
    state.authentication.dkim.data = payload
  },
  SET_SPF_DATA: (state, payload) => {
    state.authentication.spf.data = payload
  },
  SET_DKIM_LOADING_STATUS: (state, payload) => {
    state.authentication.dkim.loading_status = payload
  },
  SET_SPF_LOADING_STATUS: (state, payload) => {
    state.authentication.spf.loading_status = payload
  },

  // SET_SPAM_SETTINGS: (state, payload) => {
  //   state.spam_assasin.settings = payload
  // },
  // SET_SPAM_FILTER: (state, payload) => {
  //   state.spam_filters.spam_enabled = payload.spam_enabled
  //
  //   state.spam_filters.other = payload
  // },

  CLEAR_EMAIL_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async getDomains ({ commit }, _username) {
    const data = {
      uapi_module: 'DomainInfo',
      uapi_function: 'list_domains',
      _username,
    }

    try {
      const query = await amapi.cpanel_uapi(data)
      commit('SET_DOMAINS', query.data)
    } catch (e) {
      throw e
    }
  },
  async getDefaultAccount ({ dispatch, commit }) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'list_default_address',
    }

    try {
      const query = await amapi.cpanel_uapi({ ...data })
      commit('SET_DEFAULT_ACCOUNT', query.data[0])
    } catch (e) {
      throw e
    }
  },
  async setEmailsData ({ dispatch, commit }, user) {
    try {
      commit('SET_EMAILS_LOADING', true)

      const data = {
        uapi_module: 'Email',
        uapi_function: 'list_pops_with_disk',
        additional: { skip_main: 1 },
        _username: user,
      }

      const response = await amapi.cpanel_uapi(data)
      commit('SET_EMAILS_DATA', response.data)
    } catch (e) {
      console.warn(e)
      throw e
    } finally {
      commit('SET_EMAILS_LOADING', false)
    }
  },

  /**
    * https://api.docs.cpanel.net/openapi/cpanel/operation/add_pop/
    **/
  async createEmail ({ dispatch, commit }, { email, password, domain, quota, username }) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'add_pop',
      email: email,
      password: password,
      domain: domain,
      quota: quota,
      _username: username,
    }
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setEmailsData', username)
    } catch (e) {
      throw e
    }
  },

  async sendClientSettings ({ dispatch, commit }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
  async setSharedBookStatus ({ dispatch, commit }, name) {
    try {
      const data = {
        uapi_module: 'DAV',
        uapi_function: 'has_shared_global_addressbook',
        name
      }

      const response = await amapi.cpanel_uapi({ ...data })
      commit('SET_SHARED_BOOK_STATUS', response.data.shared)
    } catch (e) {
      throw e
    }
  },
  async setDefaultAccountData ({ dispatch, commit }) {
    try {
      commit('SET_DEFAULT_ACCOUNT_LOADING', true)
      const payload = {}

      const data = {
        uapi_module: 'Email',
        uapi_function: 'list_pops'
      }
      const usage_data = {
        uapi_module: 'Email',
        uapi_function: 'get_main_account_disk_usage'
      }

      const response = await amapi.cpanel_uapi({ ...data })
      const usage_response = await dispatch('cpanel_uapi', { ...usage_data })

      const defaultAccountData = response.data[response.data.length - 1]
      payload.email = defaultAccountData.email
      payload.usage = usage_response.data

      commit('SET_DEFAULT_ACCOUNT_DATA', payload)
      commit('SET_DEFAULT_ACCOUNT_LOADING', false)
    } catch (e) {
      commit('SET_DEFAULT_ACCOUNT_LOADING', true)
      throw e
    }
  },
  async deleteEmail ({ dispatch, commit }, email, _username) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'delete_pop',
      email,
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setEmailsData', _username)
    } catch (e) {
      throw e
    }
  },
  async changeQuota ({ dispatch }, { email, domain, quota, _username }) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'edit_pop_quota',
      email,
      domain,
      quota,
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setEmailsData', _username)
    } catch (e) {
      throw e
    }
  },
  async changePassword ({ dispatch }, { email, password, domain, _username }) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'passwd_pop',
      email,
      password,
      domain,
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
  setForwarderDomain ({ commit }, payload) {
    commit('SET_FORWARDER_DOMAIN', payload)
  },
  async setForwarders ({ dispatch, commit }, { domain, _username }) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'list_forwarders',
      _username,
      domain
    }
    const data1 = {
      uapi_module: 'Email',
      uapi_function: 'list_domain_forwarders',
      _username,
      domain
    }

    try {
      const q1 = amapi.cpanel_uapi({ ...data })
      const q2 = amapi.cpanel_uapi({ ...data1 })

      const response = await Promise.all([q1, q2])

      commit('SET_LIST_FORWARDERS', response[0].data)
      commit('SET_LIST_DOMAINS_FORWARDERS', response[1].data)
    } catch (e) {
      throw e
    }
  },
  async addForwarder ({ commit }, payload) {
    try {
      const data = {
        uapi_module: 'Email',
        uapi_function: 'add_forwarder',
        ...payload
      }

      return await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
  async addEmailForwarder ({ commit }, payload) {
    try {
      const data = {
        uapi_module: 'Email',
        uapi_function: 'add_domain_forwarder',
        ...payload
      }

      return await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
  async removeForwarder ({ commit }, payload) {
    try {
      const data = {
        uapi_module: 'Email',
        uapi_function: 'delete_forwarder',
        ...payload
        // address: this.dest,
        // forwarder: this.forward
      }
      return await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
  async removeDomainForwarder ({ commit }, payload) {
    try {
      const data = {
        uapi_module: 'Email',
        uapi_function: 'delete_domain_forwarder',
        ...payload
      }
      return await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },

  setRespondersDomain ({ commit }, payload) {
    commit('SET_RESPONDERS_DOMAIN', payload)
  },
  setRespondersStatus ({ commit }, payload) {
    commit('SET_RESPONDERS_LOADING', payload)
  },
  async setResponders ({ dispatch, commit }, { domain, _username }) {
    dispatch('setRespondersStatus', true)
    const data = {
      uapi_module: 'Email',
      uapi_function: 'list_auto_responders',
      domain,
      _username
    }

    try {
      const query = await amapi.cpanel_uapi({ ...data })
      commit('SET_RESPONDERS', query.data)
      dispatch('setRespondersStatus', false)
    } catch (e) {
      dispatch('setRespondersStatus', false)
      throw e
    }
  },
  async addResponder ({ dispatch, commit }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setResponders', { domain: data.domain, _username: data._username })
    } catch (e) {
      throw e
    }
  },
  async editResponder ({ dispatch, commit }, data) {
    try {
      commit('SET_RESPONDER', {})
      const response = await amapi.cpanel_uapi({ ...data })
      commit('SET_RESPONDER', response.data)
    } catch (e) {
      throw e
    }
  },
  async deleteResponder ({ state, dispatch, commit }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setResponders', { domain: state.responders.domain, _username: data._username })
    } catch (e) {
      throw e
    }
  },
  async setCharsets ({ dispatch, commit }) {
    commit('SET_CHARSET_STATUS', true)
    const data = {
      uapi_module: 'Email',
      uapi_function: 'get_charsets',
    }

    try {
      const query = await amapi.cpanel_uapi({ ...data })
      commit('SET_CHARSETS', query.data)
      commit('SET_CHARSET_STATUS', false)
    } catch (e) {
      commit('SET_CHARSET_STATUS', false)
      throw e
    }
  },

  setDefaultAddressDomain ({ commit }, payload) {
    commit('SET_ADDRESS_DOMAIN', payload)
  },
  async setDefaultAddressData ({ state, dispatch, commit }) {
    commit('SET_ADDRESS_LOADING', true)
    const data = {
      uapi_module: 'Email',
      uapi_function: 'list_default_address',
      domain: state.default_address.domain
    }

    try {
      const query = await amapi.cpanel_uapi({ ...data })
      commit('SET_ADDRESS_DATA', query.data[0])
      commit('SET_ADDRESS_LOADING', false)
    } catch (e) {
      commit('SET_ADDRESS_LOADING', false)
      throw e
    }
  },
  async changeDefaultAddress ({ commit, dispatch }, data) {
    commit('SET_ADDRESS_LOADING', true)
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setDefaultAddressData')
      commit('SET_ADDRESS_LOADING', false)
    } catch (e) {
      commit('SET_ADDRESS_LOADING', false)
      throw e
    }
  },

  async setMailingListData ({ dispatch, commit }) {
    dispatch('setMailingListLoading', true)
    const data = {
      uapi_module: 'Email',
      uapi_function: 'list_lists',
    }

    try {
      const query = await amapi.cpanel_uapi({ ...data })
      commit('SET_MAILING_LIST_DATA', query.data)
      dispatch('setMailingListLoading', false)
    } catch (e) {
      dispatch('setMailingListLoading', false)
      throw e
    }
  },
  setMailingListLoading ({ commit }, status) {
    commit('SET_MAILING_LIST_LOADING', status)
  },
  async updateMailingListPrivacy ({ dispatch, commit }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setMailingListData')
    } catch (e) {
      throw e
    }
  },
  async deleteMailingList ({ dispatch, commit }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setMailingListData')
    } catch (e) {
      throw e
    }
  },
  async updateMailingListPass ({ dispatch }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
  async getDelegateUserData ({ dispatch, commit }, data) {
    try {
      commit('SET_MAILING_DELEGATES_LOADING', true)

      const data_for_emails = {
        uapi_module: 'Email',
        uapi_function: 'list_pops_with_disk',
        additional: { skip_main: 1 }
      }

      const admin_query = await amapi.cpanel_uapi({ ...data })
      const user_query = amapi.cpanel_uapi({ ...data_for_emails })
      // const user_query = await dispatch('cpanel_uapi', { ...data_for_emails })

      const admins = admin_query.data.delegates
      const users = []

      user_query.data.forEach(item => {
        users.push(item.email)
      })

      commit('SET_MAILING_DELEGATES', { admins, users })
      commit('SET_MAILING_DELEGATES_LOADING', false)
    } catch (e) {
      throw e
    }
  },

  async setFilters ({ dispatch, commit, state }, { account, _username }) {
    commit('SET_FILTERS_LOADING', true)

    const data = {
      uapi_module: 'Email',
      uapi_function: 'list_filters',
      account,
      _username,
    }

    try {
      const response = await amapi.cpanel_uapi({ ...data })
      commit('SET_FILTERS_DATA', response.data)
      commit('SET_FILTERS_LOADING', false)
    } catch (e) {
      commit('SET_FILTERS_LOADING', false)
      throw e
    }
  },
  async addNewFilter ({ dispatch, commit }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setFilters', { account: data.account, _username: data._username })
    } catch (e) {
      throw e
    }
  },
  async setFilter ({ dispatch, commit }, { account, filter, _username }) {
    commit('SET_FILTER_LOADING', true)
    const data = {
      uapi_module: 'Email',
      uapi_function: 'get_filter',
      account,
      filtername: filter,
      _username,
    }

    try {
      const response = await amapi.cpanel_uapi({ ...data })
      commit('SET_FILTER_DATA', response.data)
      commit('SET_FILTER_LOADING', false)
    } catch (e) {
      commit('SET_FILTER_LOADING', false)
      throw e
    }
  },
  async deleteFilter ({ dispatch, commit, state }, data) {
    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('setFilters', data.account)
    } catch (e) {
      throw e
    }
  },
  async composeEmails ({ dispatch, commit }, _username) {
    commit('SET_FILTERS_BY_USER_LOADING', true)
    const data = []

    try {
      const email_data = {
        uapi_module: 'Email',
        uapi_function: 'list_pops',
        _username,
      }

      // const response = await dispatch('cpanel_uapi', { ...email_data })
      const response = await amapi.cpanel_uapi({ ...email_data })

      response.data.forEach(item => {
        data.push({
          email: item.email
        })
      })

      commit('SET_FILTERS_BY_USER', data)
      commit('SET_FILTERS_BY_USER_LOADING', false)
    } catch (e) {
      commit('SET_FILTERS_BY_USER_LOADING', false)
      throw e
    }
  },

  async setDKIMStatus ({ dispatch, commit }) {
    try {
      const data = {
        api2_module: 'DKIMUI',
        api2_method: 'installed'
      }
      const response = await amapi.cpanel_api2({ ...data })
      commit('SET_DKIM_STATUS', response.data[0])
    } catch (e) {
      throw e
    }
  },
  async setDKIMData ({ dispatch, commit }) {
    try {
      commit('SET_DKIM_LOADING_STATUS', true)
      const data = {
        api2_module: 'DKIMUI',
        api2_method: 'getrecords'
      }
      const response = await amapi.cpanel_api2({ ...data })
      commit('SET_DKIM_DATA', response.data)
      commit('SET_DKIM_LOADING_STATUS', false)
    } catch (e) {
      commit('SET_DKIM_LOADING_STATUS', false)
      throw e
    }
  },
  async switchDKIM ({ dispatch }, type) {
    try {
      let action_type = (type === 'install') ? 'installed' : 'uninstalled'

      const data = {
        api2_module: 'DKIMUI',
        api2_method: type
      }
      const response = await amapi.cpanel_api2({ ...data })
      let message = ''
      response.data.forEach(item => {
        message = item
      })
      return Promise.resolve(message[action_type])
    } catch (e) {
      throw e
    }
  },
  async setSPFStatus ({ dispatch, commit }) {
    try {
      const data = {
        api2_module: 'SPFUI',
        api2_method: 'installed'
      }
      const response = await amapi.cpanel_api2({ ...data })
      commit('SET_SPF_STATUS', response.data[0])
    } catch (e) {
      throw e
    }
  },
  async setSPFData ({ dispatch, commit }) {
    try {
      commit('SET_SPF_LOADING_STATUS', true)

      const data = {
        api2_module: 'SPFUI',
        api2_method: 'get_raw_record'
      }
      const response = await amapi.cpanel_api2({ ...data })
      commit('SET_SPF_DATA', response.data)
      commit('SET_SPF_LOADING_STATUS', false)
    } catch (e) {
      throw e
    }
  },
  async switchSPF ({ dispatch, commit }, type) {
    try {
      const data = {
        api2_module: 'SPFUI',
        api2_method: type
      }
      const action_type = (type === 'install') ? 'installed' : 'uninstalled'
      const response = await amapi.cpanel_api2({ ...data })
      let message = ''
      response.data.forEach(item => {
        message = item[action_type]
      })
      await dispatch('setSPFStatus')
      await dispatch('setSPFData')
      return Promise.resolve(message)
    } catch (e) {
      throw e
    }
  },

  // Spam Filters Begin
  // async setSpamSettings ({ dispatch, commit }) {
  //   const data = {
  //     uapi_module: 'Email',
  //     uapi_function: 'get_spam_settings'
  //   }
  //
  //   try {
  //     const response = await amapi.cpanel_uapi({ ...data })
  //     commit('SET_SPAM_SETTINGS', response.data)
  //   } catch (e) {
  //     throw e
  //   }
  // },
  // async getSpamSettings ({ commit }) {
  //   const data = {
  //     uapi_module: 'Email',
  //     uapi_function: 'get_spam_settings'
  //   }
  //
  //   try {
  //     const response = await amapi.cpanel_uapi({ ...data })
  //     commit('SET_SPAM_FILTER', response.data)
  //   } catch (e) {
  //     throw e
  //   }
  // },

  // async enableSpamAssasin ({ dispatch }) {
  //   const data = {
  //     uapi_module: 'Email',
  //     uapi_function: 'enable_spam_assassin',
  //   }
  //
  //   try {
  //     await amapi.cpanel_uapi({ ...data })
  //     dispatch('setSpamSettings')
  //   } catch (e) {
  //     throw e
  //   }
  // },
  // async disableSpamAssasin ({ dispatch }) {
  //   const data = {
  //     uapi_module: 'Email',
  //     uapi_function: 'disable_spam_assassin',
  //   }
  //
  //   try {
  //     await amapi.cpanel_uapi({ ...data })
  //     dispatch('setSpamSettings')
  //   } catch (e) {
  //     throw e
  //   }
  // },
  // async addSpamFilter ({ dispatch }, required_score) {
  //   const data = {
  //     uapi_module: 'Email',
  //     uapi_function: 'add_spam_filter',
  //     required_score
  //   }
  //
  //   try {
  //     const query = await amapi.cpanel_uapi({ ...data })
  //     dispatch('setSpamSettings')
  //     return Promise.resolve(query)
  //   } catch (e) {
  //     throw e
  //   }
  // },
  // async disableSpamAutoDelete ({ dispatch }) {
  //   const data = {
  //     uapi_module: 'Email',
  //     uapi_function: 'disable_spam_autodelete',
  //   }
  //
  //   try {
  //     await amapi.cpanel_uapi({ ...data })
  //     dispatch('setSpamSettings')
  //   } catch (e) {
  //     throw e
  //   }
  // },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
